export default "__VITE_ASSET__5YpZnTK2__"